import React from 'react'

function Tooltip({ children, tooltipText }) {
    const tipRef = React.createRef(null);
    function handleMouseEnter() {
        tipRef.current.style.opacity = 1;
        tipRef.current.style.marginTop = "-2px";
    }
    function handleMouseLeave() {
        tipRef.current.style.opacity = 0;
        tipRef.current.style.marginTop = "-20px";
    }
    return (
        <div
            className="relative flex flex-column items-center cursor-help"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <div
                className="absolute text-white text-xs bg-gray-700 px-4 py-1 rounded-sm flex items-center transition-all duration-150"
                style={{ top: "100%", opacity: 0, zIndex: 1000000 }}
                ref={tipRef}
            >
                <div
                    className="bg-gray-700 h-2 w-2 absolute"
                    style={{ left: "50%", top: '-1px', transform: "rotate(45deg) translateX(-50%)" }}
                />
                {tooltipText}
            </div>
            {children}
        </div>
    );
}

export default Tooltip
